// Single source of truth for application routes.

import { lazy, type LazyExoticComponent, type ComponentType, type ReactNode } from 'react';

const HomePage = lazy(() => import('@pages/HomePage'));
const ResultsPage = lazy(() => import('@pages/ResultsPage'));
const NotFoundPage = lazy(() => import('@pages/NotFoundPage'));

export const ROUTE_PATHS = {
  HOME: '/',
  RESULTS: '/results/:sessionId',
  NOT_FOUND: '*',
} as const;

export type RoutePathKey = keyof typeof ROUTE_PATHS;
export type RoutePath = (typeof ROUTE_PATHS)[RoutePathKey];

export interface RouteMeta {
  label?: string;
  showInNav?: boolean;
  end?: boolean;
}

export interface RouteEntry {
  path: RoutePath;
  component: LazyExoticComponent<ComponentType<unknown>>;
  fallback?: ReactNode;
  meta?: RouteMeta;
}

export const routes: readonly RouteEntry[] = [
  {
    path: ROUTE_PATHS.HOME,
    component: HomePage,
    meta: { label: 'Home', showInNav: true, end: true },
  },
  {
    path: ROUTE_PATHS.RESULTS,
    component: ResultsPage,
    meta: { label: 'Results', showInNav: false },
  },
  {
    path: ROUTE_PATHS.NOT_FOUND,
    component: NotFoundPage,
  },
];

export const navRoutes: readonly RouteEntry[] = routes.filter(
  (route) => route.meta?.showInNav === true,
);

export const resultsPath = (sessionId: string): string => `/results/${sessionId}`;
